import {Button, Col, Collapse, Divider, Drawer, Form, Input, Row} from "antd";
import React, {useEffect, useMemo, useState} from "react";
import {useSaveContactMutation} from "@mwServices/User";
import {showResponse} from "@services/Api";
import useHasPermission from "@hooks/useHasPermission";
import {useWindowSize} from "@components/window-size-provider";

const { Panel } = Collapse;

interface AddEditContactDrawerProps {
    contact?: any;
    visible: boolean;
    onClose: () => void;
}

const defaultProps: AddEditContactDrawerProps = {
    visible: false,
    onClose: () => {},
}

const AddEditContactDrawerContent = ({contact, form, onClose}) => {
    const [postSaveContact, saveContactResponse] = useSaveContactMutation();
    const initForm = useMemo(() => (contact ? {
        ...contact,
    } : {}), [contact]);

    useEffect(() => form.resetFields(), [initForm]);

    useEffect(() => {
        showResponse(saveContactResponse, 'Contact saved.', 'Sorry, there was a problem saving the contact.');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveContactResponse]);

    const submitForm = async (values) => {
        let sanitisedData = {
            ...values
        };

        if(contact) sanitisedData.contact_id = contact.id;

        await postSaveContact(sanitisedData);

        form.resetFields();
        onClose();
    };

    return (
        <>
            <Form
                labelCol={{span: 10}}
                wrapperCol={{span: 14}}
                form={form}
                initialValues={initForm}
                onFinish={submitForm}
            >
            <Row>
                <Col span={24}>
                    <Collapse ghost className="editSections" defaultActiveKey={[1]} expandIconPosition={"end"}>
                        <Panel header={"Contact Details"} key={1}>
                            <Row>
                                <Col span={6} className="align-left-top">
                                </Col>
                                <Col span={18}>
                                    <Form.Item label="Name" name={`contact_name`}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item label="Store Name" name={`store_name`}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item label="Email" name={`email`}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item label="Phone" name={`phone`}>
                                        <Input placeholder="" />
                                    </Form.Item>

                                    <Divider />

                                    <Form.Item label={"Address 1"} name={`address1`}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item label={"Address 2"} name={`address2`} >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item label={"Address 3"} name={`address3`} >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item label={"Address 4"} name={`address4`} >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item label="City" name={`city`}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item label="State" name={`state`}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item label="Zip Code" name={`zip`}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>
            </Form>
        </>
    );
};

const AddEditContactDrawer = ({contact, visible, onClose}: AddEditContactDrawerProps) => {
    const [form] = Form.useForm();
    const windowDimensions = useWindowSize();
    const [drawerWidth, setDrawerWidth] = useState(450);
    const isAdmin = useHasPermission('admin');

    useEffect(() => {
        const newWidth = (windowDimensions.width < 450) ? windowDimensions.width : 450;
        if(newWidth !== drawerWidth) setDrawerWidth(newWidth);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowDimensions]);

    const onCloseExec = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Drawer
            title={contact ? "Edit Contact" : "Add Contact"}
            className="add-edit-contact-drawer"
            headerStyle={{paddingTop: isAdmin ? 50 : 16}}
            width={drawerWidth}
            placement="right"
            onClose={onClose}
            open={visible}
            footer={
                <Row justify="center">
                    <Col >
                        <Button className="outlineButton thickButton width-250px"  onClick={() => form.submit()}>SAVE</Button>
                    </Col>
                </Row>
            }
        >
            {visible && (
                <AddEditContactDrawerContent contact={contact} onClose={onCloseExec} form={form} />
            )}

        </Drawer>
    );
};

AddEditContactDrawer.defaultProps = defaultProps;

export default AddEditContactDrawer;